export default __webpack_public_path__ + "static/media/login-bg.f16d1af8.webp";